import { render, staticRenderFns } from "./shop-summary.vue?vue&type=template&id=5df6a7c4&scoped=true&"
import script from "./shop-summary.vue?vue&type=script&lang=js&"
export * from "./shop-summary.vue?vue&type=script&lang=js&"
import style0 from "./shop-summary.vue?vue&type=style&index=0&id=5df6a7c4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df6a7c4",
  null
  
)

export default component.exports